import { useSelector } from "react-redux";
import { selectSupportedApps } from "../../redux/features/connectedApps/connectedAppsSlice";
import { Autocomplete } from "./Autocomplete";
import { LinkRecord, getUnifiedIconPath } from "winslow-core";
import "./ResourceAutocomplete.css";

type ResourceAutocompleteProps = {
  onChange: (value: string) => void;
  placeholder?: string;
  resources: LinkRecord[];
  disabled?: boolean;
  value?: string | null;
};

export const ResourceAutocomplete = ({
  onChange,
  placeholder = "Select resource...",
  resources,
  disabled = false,
  value,
}: ResourceAutocompleteProps) => {
  const supportedApps = useSelector(selectSupportedApps);
  const getLinkRecordLabel = (resource: LinkRecord) => {
    return resource.links?.[0]?.title || resource.canonicalId;
  };

  const getLinkRecordImageUrl = (resource: LinkRecord) => {
    return getUnifiedIconPath(
      { linkRecord: resource },
      supportedApps || [],
      { theme: "light-mode", forceActivity: true }
    );
  };

  // Convert personas to option format
  const options = resources.map((resource) => ({
    value: resource.id,
    label: getLinkRecordLabel(resource),
    imageUrl: getLinkRecordImageUrl(resource),
  }));

  return (
    <Autocomplete
      openOnTop={false}
      placeholder={placeholder}
      options={[options]}
      sectionLabels={[]}
      onChange={onChange}
      roundIcons={false}
      disabled={disabled}
      value={value || ""}
    />
  );
};
